<template>
  <h4>LookForwardTotals.vue</h4>
</template>

<script>
export default {
  data() {},
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
